
            //------------------------------------------------------------------------------
            // <auto-generated>
            //     This code was generated from a template.
            //
            //     Manual changes to this file may cause unexpected behavior in your application.
            //     Manual changes to this file will be overwritten if the code is regenerated.
            // </auto-generated>
            //------------------------------------------------------------------------------
        
	export enum JobsLoginStatus {
		 NOTINVITED = 'NotInvited',
		 INVITED = 'Invited',
		 CONFIRMED = 'Confirmed',
	}


	export enum IssueStatus {
		 OPEN = 'Open',
		 CANCELLED = 'Cancelled',
		 RESOLVED = 'Resolved',
		 SNOOZED = 'Snoozed',
	}


	export enum IssueCategoryType {
		 STRUCTURAL = 'Structural',
		 FINISHING = 'Finishing',
		 TECHNICAL = 'Technical',
		 SECURITY = 'Security',
		 CONFORMITYANDSAFETY = 'ConformityAndSafety',
		 MAINTENANCE = 'Maintenance',
	}


	export enum IssueType {
		 STRUCTURAL = 'Structural',
		 REMOVAL = 'Removal',
		 MISSING = 'Missing',
		 MATERIALS = 'Materials',
		 MARKINGS = 'Markings',
		 INTEGRITY = 'Integrity',
		 INSPECTION = 'Inspection',
		 HUMIDITY = 'Humidity',
		 GENERAL = 'General',
		 FUNCTIONALITY = 'Functionality',
		 EQUIPMENT = 'Equipment',
		 DISABILITY = 'Disability',
		 DEGRADATION = 'Degradation',
		 CONFORMITY = 'Conformity',
		 CLEANLINESS = 'Cleanliness',
		 ACCESSIBILITY = 'Accessibility',
		 DIRTY = 'Dirty',
		 DAMAGE = 'Damage',
		 CLEANING = 'Cleaning',
		 PAINTING = 'Painting',
		 REPAIRING = 'Repairing',
		 ALERT = 'Alert',
	}


	export enum MaintenanceProductType {
		 LITE = 'Lite',
		 PRO = 'Pro',
	}


	export enum Permission {
		 INTERVENTIONS = 'Interventions',
	}


	export enum StructureContactType {
		 TENANT = 'Tenant',
		 RESPONSIBLE = 'Responsible',
		 OWNER = 'Owner',
		 JANITOR = 'Janitor',
		 MANAGER = 'Manager',
	}


	export enum StructureType {
		 BUILDING = 'Building',
		 FLOOR = 'Floor',
		 SPACE = 'Space',
		 PRIVATEUNITS = 'PrivateUnits',
		 LIVINGUNIT = 'LivingUnit',
		 COMMERCIALUNIT = 'CommercialUnit',
		 METERS = 'Meters',
		 UTILITIES = 'Utilities',
		 UTILITY = 'Utility',
		 BUILDINGENVELOPE = 'BuildingEnvelope',
		 BUILDINGENVELOPEELEMENT = 'BuildingEnvelopeElement',
		 EXTERIOR = 'Exterior',
		 EXTERIORELEMENT = 'ExteriorElement',
		 BASICELEMENTGROUP = 'BasicElementGroup',
		 BASICELEMENT = 'BasicElement',
		 SPECIFICELEMENTGROUP = 'SpecificElementGroup',
		 SPECIFICELEMENT = 'SpecificElement',
		 CONFORMITYELEMENTGROUP = 'ConformityElementGroup',
		 CONFORMITYELEMENT = 'ConformityElement',
		 SITE = 'Site',
	}


	export enum JobDueDates {
		 TODAY = 'Today',
		 TOMORROW = 'Tomorrow',
		 THISWEEK = 'ThisWeek',
		 NEXTWEEK = 'NextWeek',
		 SPECIFICDATE = 'SpecificDate',
		 NODATE = 'NoDate',
	}


	export enum JobTimes {
		 AM = 'AM',
		 PM = 'PM',
		 MORNING = 'Morning',
		 ENDOFDAY = 'EndOfDay',
		 SPECIFICTIME = 'SpecificTime',
		 NOTIME = 'NoTime',
	}


	export enum AcceptedJobSteps {
		 DEFAULT = 'Default',
		 DATE = 'Date',
		 TIME = 'Time',
	}


	export enum ActionSearchSortBy {
		 DUEDATE = 'DueDate',
		 WORKORDERREFERENCE = 'WorkOrderReference',
	}


	export enum ApplicationSourceType {
		 CHAPPSBUILDINGMANAGERSERVICE = 'ChappsBuildingManagerService',
		 CHAPPSBUILDINGADMINSERVICE = 'ChappsBuildingAdminService',
		 CHAPPSBUILDINGAPPSERVICE = 'ChappsBuildingAppService',
		 CHAPPSBUILDINGADMINFRONTEND = 'ChappsBuildingAdminFrontend',
		 CHAPPSBUILDINGMANAGERFRONTEND = 'ChappsBuildingManagerFrontend',
		 CHAPPSBUILDINGAPP = 'ChappsBuildingApp',
		 CHAPPSBUILDINGWEBSITE = 'ChappsBuildingWebSite',
		 CHAPPSBUILDINGRECURRINGPAYMENTS = 'ChappsBuildingRecurringPayments',
		 CHAPPSRESIDENZ = 'ChappsResidenz',
		 CHAPPSRESIDENZWEBSITEFRONTEND = 'ChappsResidenzWebSiteFrontend',
		 CHAPPSRESIDENZMANAGERSERVICE = 'ChappsResidenzManagerService',
		 CHAPPSRESIDENZMANAGERFRONTEND = 'ChappsResidenzManagerFrontend',
		 CHAPPSMAINTENANCEMANAGERFRONTEND = 'ChappsMaintenanceManagerFrontend',
		 CHAPPSMAINTENANCEMANAGERSERVICE = 'ChappsMaintenanceManagerService',
		 CHAPPSMAINTENANCEMANAGERAPP = 'ChappsMaintenanceManagerApp',
		 UNKNOWN = 'Unknown',
		 CHAPPREPORTENGINE = 'ChappReportEngine',
		 CHAPPREPORTSERVICE = 'ChappReportService',
		 CHAPPREPORTPROCESSORSERVICE = 'ChappReportProcessorService',
		 CHAPPREPORTSITE = 'ChappReportSite',
		 CHAPPREPORTAPP = 'ChappReportApp',
		 CHAPPREPORTAPI = 'ChappReportApi',
		 CHAPPSROOMSWEBFACADE = 'ChappsRoomsWebFacade',
		 CHAPPSROOMSWEBSERVICE = 'ChappsRoomsWebService',
		 CHAPPSROOMSAPP = 'ChappsRoomsApp',
		 CHAPPSROOMSWEBADMIN = 'ChappsRoomsWebAdmin',
		 CHAPPSROOMSREPORTSENDER = 'ChappsRoomsReportSender',
		 CHAPPREPORTMAILLINK = 'ChappReportMailLink',
		 CHAPPREPORTDWHCORRECTIONS = 'ChappReportDWHCorrections',
		 CHAPPREPORTPRODUCTCHECKER = 'ChappReportProductChecker',
		 CHAPPREPORTPARTNER = 'ChappReportPartner',
		 CHAPPSACCOUNTFRONTEND = 'ChappsAccountFrontend',
		 CHAPPSACCOUNTSERVICE = 'ChappsAccountService',
		 CHAPPSMAILSERVICE = 'ChappsMailService',
		 BUILDINGINSPECTIONAPP = 'BuildingInspectionApp',
		 CHAPPSBUILDINGWEBSERVICE = 'ChappsBuildingWebService',
		 RESIDENZMANAGER = 'ResidenzManager',
		 CHAPPSADMINFRONTEND = 'ChappsAdminFrontend',
		 CHAPPSADMIN = 'ChappsAdmin',
		 CHAPPSMAINTENANCEJOBSFRONTEND = 'ChappsMaintenanceJobsFrontend',
		 CHAPPSMAINTENANCEJOBSSERVICE = 'ChappsMaintenanceJobsService',
	}


	export enum ApplicationType {
		 ACCOUNT = 'Account',
		 RENTAL = 'Rental',
		 ROOMS = 'Rooms',
		 BUILDING = 'Building',
		 RESIDENZ = 'Residenz',
		 RESIDENZWEBSITE = 'ResidenzWebSite',
		 ADMIN = 'Admin',
		 MAINTENANCE = 'Maintenance',
		 MAIL = 'Mail',
	}


	export enum CountryType {
		 AD = 'AD',
		 AE = 'AE',
		 AF = 'AF',
		 AG = 'AG',
		 AI = 'AI',
		 AL = 'AL',
		 AM = 'AM',
		 AO = 'AO',
		 AQ = 'AQ',
		 AR = 'AR',
		 AS = 'AS',
		 AT = 'AT',
		 AU = 'AU',
		 AW = 'AW',
		 AX = 'AX',
		 AZ = 'AZ',
		 BA = 'BA',
		 BB = 'BB',
		 BD = 'BD',
		 BE = 'BE',
		 BF = 'BF',
		 BG = 'BG',
		 BH = 'BH',
		 BI = 'BI',
		 BJ = 'BJ',
		 BL = 'BL',
		 BM = 'BM',
		 BN = 'BN',
		 BO = 'BO',
		 BQ = 'BQ',
		 BR = 'BR',
		 BS = 'BS',
		 BT = 'BT',
		 BV = 'BV',
		 BW = 'BW',
		 BY = 'BY',
		 BZ = 'BZ',
		 CA = 'CA',
		 CC = 'CC',
		 CD = 'CD',
		 CF = 'CF',
		 CG = 'CG',
		 CH = 'CH',
		 CI = 'CI',
		 CK = 'CK',
		 CL = 'CL',
		 CM = 'CM',
		 CN = 'CN',
		 CO = 'CO',
		 CR = 'CR',
		 CU = 'CU',
		 CV = 'CV',
		 CW = 'CW',
		 CX = 'CX',
		 CY = 'CY',
		 CZ = 'CZ',
		 DE = 'DE',
		 DJ = 'DJ',
		 DK = 'DK',
		 DM = 'DM',
		 DO = 'DO',
		 DZ = 'DZ',
		 EC = 'EC',
		 EE = 'EE',
		 EG = 'EG',
		 EH = 'EH',
		 ER = 'ER',
		 ES = 'ES',
		 ET = 'ET',
		 FI = 'FI',
		 FJ = 'FJ',
		 FK = 'FK',
		 FM = 'FM',
		 FO = 'FO',
		 FR = 'FR',
		 GA = 'GA',
		 GB = 'GB',
		 GD = 'GD',
		 GE = 'GE',
		 GF = 'GF',
		 GG = 'GG',
		 GH = 'GH',
		 GI = 'GI',
		 GL = 'GL',
		 GM = 'GM',
		 GN = 'GN',
		 GP = 'GP',
		 GQ = 'GQ',
		 GR = 'GR',
		 GS = 'GS',
		 GT = 'GT',
		 GU = 'GU',
		 GW = 'GW',
		 GY = 'GY',
		 HK = 'HK',
		 HM = 'HM',
		 HN = 'HN',
		 HR = 'HR',
		 HT = 'HT',
		 HU = 'HU',
		 ID = 'ID',
		 IE = 'IE',
		 IL = 'IL',
		 IM = 'IM',
		 IN = 'IN',
		 IO = 'IO',
		 IQ = 'IQ',
		 IR = 'IR',
		 IS = 'IS',
		 IT = 'IT',
		 JE = 'JE',
		 JM = 'JM',
		 JO = 'JO',
		 JP = 'JP',
		 KE = 'KE',
		 KG = 'KG',
		 KH = 'KH',
		 KI = 'KI',
		 KM = 'KM',
		 KN = 'KN',
		 KP = 'KP',
		 KR = 'KR',
		 KW = 'KW',
		 KY = 'KY',
		 KZ = 'KZ',
		 LA = 'LA',
		 LB = 'LB',
		 LC = 'LC',
		 LI = 'LI',
		 LK = 'LK',
		 LR = 'LR',
		 LS = 'LS',
		 LT = 'LT',
		 LU = 'LU',
		 LV = 'LV',
		 LY = 'LY',
		 MA = 'MA',
		 MC = 'MC',
		 MD = 'MD',
		 ME = 'ME',
		 MF = 'MF',
		 MG = 'MG',
		 MH = 'MH',
		 MK = 'MK',
		 ML = 'ML',
		 MM = 'MM',
		 MN = 'MN',
		 MO = 'MO',
		 MP = 'MP',
		 MQ = 'MQ',
		 MR = 'MR',
		 MS = 'MS',
		 MT = 'MT',
		 MU = 'MU',
		 MV = 'MV',
		 MW = 'MW',
		 MX = 'MX',
		 MY = 'MY',
		 MZ = 'MZ',
		 NA = 'NA',
		 NC = 'NC',
		 NE = 'NE',
		 NF = 'NF',
		 NG = 'NG',
		 NI = 'NI',
		 NL = 'NL',
		 NO = 'NO',
		 NP = 'NP',
		 NR = 'NR',
		 NU = 'NU',
		 NZ = 'NZ',
		 OM = 'OM',
		 PA = 'PA',
		 PE = 'PE',
		 PF = 'PF',
		 PG = 'PG',
		 PH = 'PH',
		 PK = 'PK',
		 PL = 'PL',
		 PM = 'PM',
		 PN = 'PN',
		 PR = 'PR',
		 PS = 'PS',
		 PT = 'PT',
		 PW = 'PW',
		 PY = 'PY',
		 QA = 'QA',
		 RE = 'RE',
		 RO = 'RO',
		 RS = 'RS',
		 RU = 'RU',
		 RW = 'RW',
		 SA = 'SA',
		 SB = 'SB',
		 SC = 'SC',
		 SD = 'SD',
		 SE = 'SE',
		 SG = 'SG',
		 SH = 'SH',
		 SI = 'SI',
		 SJ = 'SJ',
		 SK = 'SK',
		 SL = 'SL',
		 SM = 'SM',
		 SN = 'SN',
		 SO = 'SO',
		 SR = 'SR',
		 SS = 'SS',
		 ST = 'ST',
		 SV = 'SV',
		 SX = 'SX',
		 SY = 'SY',
		 SZ = 'SZ',
		 TC = 'TC',
		 TD = 'TD',
		 TF = 'TF',
		 TG = 'TG',
		 TH = 'TH',
		 TJ = 'TJ',
		 TK = 'TK',
		 TL = 'TL',
		 TM = 'TM',
		 TN = 'TN',
		 TO = 'TO',
		 TR = 'TR',
		 TT = 'TT',
		 TV = 'TV',
		 TW = 'TW',
		 TZ = 'TZ',
		 UA = 'UA',
		 UG = 'UG',
		 UM = 'UM',
		 US = 'US',
		 UY = 'UY',
		 UZ = 'UZ',
		 VA = 'VA',
		 VC = 'VC',
		 VE = 'VE',
		 VG = 'VG',
		 VI = 'VI',
		 VN = 'VN',
		 VU = 'VU',
		 WF = 'WF',
		 WS = 'WS',
		 YE = 'YE',
		 YT = 'YT',
		 ZA = 'ZA',
		 ZM = 'ZM',
		 ZW = 'ZW',
	}


	export enum CurrencyType {
		 AED = 'AED',
		 AFN = 'AFN',
		 ALL = 'ALL',
		 AMD = 'AMD',
		 ANG = 'ANG',
		 AOA = 'AOA',
		 ARS = 'ARS',
		 AUD = 'AUD',
		 AWG = 'AWG',
		 AZN = 'AZN',
		 BAM = 'BAM',
		 BBD = 'BBD',
		 BDT = 'BDT',
		 BGN = 'BGN',
		 BHD = 'BHD',
		 BIF = 'BIF',
		 BMD = 'BMD',
		 BND = 'BND',
		 BOB = 'BOB',
		 BRL = 'BRL',
		 BSD = 'BSD',
		 BTN = 'BTN',
		 BWP = 'BWP',
		 BYR = 'BYR',
		 BZD = 'BZD',
		 CAD = 'CAD',
		 CDF = 'CDF',
		 CHF = 'CHF',
		 CLP = 'CLP',
		 CNY = 'CNY',
		 COP = 'COP',
		 CRC = 'CRC',
		 CSD = 'CSD',
		 CUC = 'CUC',
		 CUP = 'CUP',
		 CVE = 'CVE',
		 CZK = 'CZK',
		 DJF = 'DJF',
		 DKK = 'DKK',
		 DOP = 'DOP',
		 DZD = 'DZD',
		 EGP = 'EGP',
		 ERN = 'ERN',
		 ETB = 'ETB',
		 EUR = 'EUR',
		 FJD = 'FJD',
		 FKP = 'FKP',
		 GBP = 'GBP',
		 GEL = 'GEL',
		 GGP = 'GGP',
		 GHS = 'GHS',
		 GIP = 'GIP',
		 GMD = 'GMD',
		 GNF = 'GNF',
		 GTQ = 'GTQ',
		 GYD = 'GYD',
		 HKD = 'HKD',
		 HNL = 'HNL',
		 HRK = 'HRK',
		 HTG = 'HTG',
		 HUF = 'HUF',
		 IDR = 'IDR',
		 ILS = 'ILS',
		 IMP = 'IMP',
		 INR = 'INR',
		 IQD = 'IQD',
		 IRR = 'IRR',
		 ISK = 'ISK',
		 JEP = 'JEP',
		 JMD = 'JMD',
		 JOD = 'JOD',
		 JPY = 'JPY',
		 KES = 'KES',
		 KGS = 'KGS',
		 KHR = 'KHR',
		 KMF = 'KMF',
		 KPW = 'KPW',
		 KRW = 'KRW',
		 KWD = 'KWD',
		 KYD = 'KYD',
		 KZT = 'KZT',
		 LAK = 'LAK',
		 LBP = 'LBP',
		 LKR = 'LKR',
		 LRD = 'LRD',
		 LSL = 'LSL',
		 LTL = 'LTL',
		 LVL = 'LVL',
		 LYD = 'LYD',
		 MAD = 'MAD',
		 MDL = 'MDL',
		 MGA = 'MGA',
		 MKD = 'MKD',
		 MMK = 'MMK',
		 MNT = 'MNT',
		 MOP = 'MOP',
		 MRO = 'MRO',
		 MUR = 'MUR',
		 MVR = 'MVR',
		 MWK = 'MWK',
		 MXN = 'MXN',
		 MYR = 'MYR',
		 MZN = 'MZN',
		 NAD = 'NAD',
		 NGN = 'NGN',
		 NIO = 'NIO',
		 NOK = 'NOK',
		 NPR = 'NPR',
		 NZD = 'NZD',
		 OMR = 'OMR',
		 PAB = 'PAB',
		 PEN = 'PEN',
		 PGK = 'PGK',
		 PHP = 'PHP',
		 PKR = 'PKR',
		 PLN = 'PLN',
		 PYG = 'PYG',
		 QAR = 'QAR',
		 RON = 'RON',
		 RSD = 'RSD',
		 RUB = 'RUB',
		 RWF = 'RWF',
		 SAR = 'SAR',
		 SBD = 'SBD',
		 SCR = 'SCR',
		 SDG = 'SDG',
		 SEK = 'SEK',
		 SGD = 'SGD',
		 SHP = 'SHP',
		 SLL = 'SLL',
		 SOS = 'SOS',
		 SPL = 'SPL',
		 SRD = 'SRD',
		 STD = 'STD',
		 SVC = 'SVC',
		 SYP = 'SYP',
		 SZL = 'SZL',
		 THB = 'THB',
		 TJS = 'TJS',
		 TMT = 'TMT',
		 TND = 'TND',
		 TOP = 'TOP',
		 TRY = 'TRY',
		 TTD = 'TTD',
		 TVD = 'TVD',
		 TWD = 'TWD',
		 TZS = 'TZS',
		 UAH = 'UAH',
		 UGX = 'UGX',
		 USD = 'USD',
		 UYU = 'UYU',
		 UZS = 'UZS',
		 VEF = 'VEF',
		 VND = 'VND',
		 VUV = 'VUV',
		 WST = 'WST',
		 XAF = 'XAF',
		 XCD = 'XCD',
		 XDR = 'XDR',
		 XOF = 'XOF',
		 XPF = 'XPF',
		 YER = 'YER',
		 ZAR = 'ZAR',
		 ZMW = 'ZMW',
		 ZWD = 'ZWD',
		 ZWL = 'ZWL',
	}


	export enum EmailLogType {
		 INVITENEWUSERMAIL = 'InviteNewUserMail',
		 INVITEUSERTONEWBUILDINGMAIL = 'InviteUserToNewBuildingMail',
		 NOTIFICATIONABOUTNEWREPLYMAIL = 'NotificationAboutNewReplyMail',
		 CANCELLEDSUBSCRIPTIONMAIL = 'CancelledSubscriptionMail',
		 CHANGEPASSWORDMAIL = 'ChangePasswordMail',
		 CONFIRMACCOUNTMAIL = 'ConfirmAccountMail',
		 INSPECTIONREPORTMAIL = 'InspectionReportMail',
		 NEWBUILDINGSCREATEDMAIL = 'NewBuildingsCreatedMail',
		 NEWSTRUCTURESCREATEDMAIL = 'NewStructuresCreatedMail',
		 WELCOMEMAIL = 'WelcomeMail',
		 NEWUSERCREATEDMAIL = 'NewUserCreatedMail',
		 PAYMENTINFORMATIONMAIL = 'PaymentInformationMail',
		 RECURRINGPAYMENTFAILEDMAIL = 'RecurringPaymentFailedMail',
		 REMOVEACCOUNTMAIL = 'RemoveAccountMail',
		 THECARDWILLEXPIRESOONMAIL = 'TheCardWillExpireSoonMail',
		 UPDATEDSUBSCRIPTIONMAIL = 'UpdatedSubscriptionMail',
		 CANCELLEDDEMOSUBSCRIPTIONMAIL = 'CancelledDemoSubscriptionMail',
		 ACCOUNTINVITATION = 'AccountInvitation',
		 INVOICEMAIL = 'InvoiceMail',
		 ISSUENOTIFICATIONHANDLEDMAIL = 'IssueNotificationHandledMail',
		 NEWANNOUNCEMENTMAIL = 'NewAnnouncementMail',
		 NEWMESSAGESMAIL = 'NewMessagesMail',
		 ACCOUNTALREADYCONFIRMEDMAIL = 'AccountAlreadyConfirmedMail',
		 FEEDBACKMAIL = 'FeedbackMail',
		 JOBASSIGNEDMAIL = 'JobAssignedMail',
		 ROOMSMAILSFROMDEVICE = 'RoomsMailsFromDevice',
		 REPORTTORESIDENT = 'ReportToResident',
	}


	export enum EnvironmentType {
		 LOCAL = 'Local',
		 DEV = 'Dev',
		 STAGING = 'Staging',
		 LIVE = 'Live',
		 TEST = 'Test',
		 BART = 'Bart',
		 FLORIAN = 'Florian',
		 STIJN = 'Stijn',
	}


	export enum ErrorType {
		 UNSPECIFIED = 'Unspecified',
		 OK = 'Ok',
		 DBAERROR = 'DbaError',
		 NOTEXIST = 'NotExist',
		 ACCESSDENIED = 'AccessDenied',
		 ALREADYEXISTS = 'AlreadyExists',
		 NOTACTIVE = 'NotActive',
		 DENIEDBYPRODUCT = 'DeniedByProduct',
		 DELETED = 'Deleted',
		 INVALID = 'Invalid',
		 NOTCONFIRMED = 'NotConfirmed',
		 NODBOLOGIN = 'NoDboLogin',
		 NODBOCONTACT = 'NoDboContact',
		 NODBOADDRESS = 'NoDboAddress',
		 NODBOBUSINESS = 'NoDboBusiness',
		 NOROOMSLOGIN = 'NoRoomsLogin',
		 NOROOMSCONTACT = 'NoRoomsContact',
		 NOBUILDINGLOGIN = 'NoBuildingLogin',
		 NOBUILDINGCONTACT = 'NoBuildingContact',
		 VERSIONCONFLICT = 'VersionConflict',
		 ALREADYDELETED = 'AlreadyDeleted',
		 INVALIDCAST = 'InvalidCast',
		 INVALIDARGUMENT = 'InvalidArgument',
		 INTERNAL = 'Internal',
		 SQL = 'Sql',
		 EF = 'EF',
		 MULTIMEDIA = 'Multimedia',
		 SESSIONEXPIRED = 'SessionExpired',
		 LICENSENOTAGREED = 'LicenseNotAgreed',
		 REPORTREASSIGNED = 'ReportReAssigned',
		 REPORTUPLOAD = 'ReportUpload',
		 SERVERTOAPPMESSAGE = 'ServerToAppMessage',
		 MINIUMREQUIREDAPPVERSION = 'MiniumRequiredAppVersion',
		 SYNCTIMING = 'SyncTiming',
		 CONNECTION = 'Connection',
		 APPSTORE = 'AppStore',
		 RECOVERDATA = 'RecoverData',
		 OGONE = 'Ogone',
		 SIPS = 'Sips',
		 PUSHNOTIFICATION = 'PushNotification',
		 INVALIDLOGIN = 'InvalidLogin',
		 DENIEDBYBUSINESSRULES = 'DeniedByBusinessRules',
		 FRONTENDERROR = 'FrontendError',
		 RESERVEDID = 'ReservedId',
		 REPORTDELETE = 'ReportDelete',
		 RESIDENZWEBSITE = 'ResidenzWebSite',
		 TRANSACTIONTIME = 'TransactionTime',
		 NORENTALLOGIN = 'NoRentalLogin',
	}


	export enum GenderType {
		 FEMALE = 'Female',
		 MALE = 'Male',
		 X = 'X',
	}


	export enum LanguageType {
		 AA = 'AA',
		 AB = 'AB',
		 AE = 'AE',
		 AF = 'AF',
		 AK = 'AK',
		 AM = 'AM',
		 AN = 'AN',
		 AR = 'AR',
		 AS = 'AS',
		 AV = 'AV',
		 AY = 'AY',
		 AZ = 'AZ',
		 BA = 'BA',
		 BE = 'BE',
		 BG = 'BG',
		 BH = 'BH',
		 BI = 'BI',
		 BM = 'BM',
		 BN = 'BN',
		 BO = 'BO',
		 BR = 'BR',
		 BS = 'BS',
		 CA = 'CA',
		 CE = 'CE',
		 CH = 'CH',
		 CO = 'CO',
		 CR = 'CR',
		 CS = 'CS',
		 CU = 'CU',
		 CV = 'CV',
		 CY = 'CY',
		 DA = 'DA',
		 DE = 'DE',
		 DV = 'DV',
		 DZ = 'DZ',
		 EE = 'EE',
		 EL = 'EL',
		 EN = 'EN',
		 EO = 'EO',
		 ES = 'ES',
		 ET = 'ET',
		 EU = 'EU',
		 FA = 'FA',
		 FF = 'FF',
		 FI = 'FI',
		 FJ = 'FJ',
		 FO = 'FO',
		 FR = 'FR',
		 FY = 'FY',
		 GA = 'GA',
		 GD = 'GD',
		 GL = 'GL',
		 GN = 'GN',
		 GU = 'GU',
		 GV = 'GV',
		 HA = 'HA',
		 HE = 'HE',
		 HI = 'HI',
		 HO = 'HO',
		 HR = 'HR',
		 HT = 'HT',
		 HU = 'HU',
		 HY = 'HY',
		 HZ = 'HZ',
		 IA = 'IA',
		 ID = 'ID',
		 IE = 'IE',
		 IG = 'IG',
		 II = 'II',
		 IK = 'IK',
		 IO = 'IO',
		 IS = 'IS',
		 IT = 'IT',
		 IU = 'IU',
		 JA = 'JA',
		 JV = 'JV',
		 KA = 'KA',
		 KG = 'KG',
		 KI = 'KI',
		 KJ = 'KJ',
		 KK = 'KK',
		 KL = 'KL',
		 KM = 'KM',
		 KN = 'KN',
		 KO = 'KO',
		 KR = 'KR',
		 KS = 'KS',
		 KU = 'KU',
		 KV = 'KV',
		 KW = 'KW',
		 KY = 'KY',
		 LA = 'LA',
		 LB = 'LB',
		 LG = 'LG',
		 LI = 'LI',
		 LN = 'LN',
		 LO = 'LO',
		 LT = 'LT',
		 LU = 'LU',
		 LV = 'LV',
		 MG = 'MG',
		 MH = 'MH',
		 MI = 'MI',
		 MK = 'MK',
		 ML = 'ML',
		 MN = 'MN',
		 MR = 'MR',
		 MS = 'MS',
		 MT = 'MT',
		 MY = 'MY',
		 NA = 'NA',
		 NB = 'NB',
		 ND = 'ND',
		 NE = 'NE',
		 NG = 'NG',
		 NL = 'NL',
		 NN = 'NN',
		 NO = 'NO',
		 NR = 'NR',
		 NV = 'NV',
		 NY = 'NY',
		 OC = 'OC',
		 OJ = 'OJ',
		 OM = 'OM',
		 OR = 'OR',
		 OS = 'OS',
		 PA = 'PA',
		 PI = 'PI',
		 PL = 'PL',
		 PS = 'PS',
		 PT = 'PT',
		 QU = 'QU',
		 RM = 'RM',
		 RN = 'RN',
		 RO = 'RO',
		 RU = 'RU',
		 RW = 'RW',
		 SA = 'SA',
		 SC = 'SC',
		 SD = 'SD',
		 SE = 'SE',
		 SG = 'SG',
		 SH = 'SH',
		 SI = 'SI',
		 SK = 'SK',
		 SL = 'SL',
		 SM = 'SM',
		 SN = 'SN',
		 SO = 'SO',
		 SQ = 'SQ',
		 SR = 'SR',
		 SS = 'SS',
		 ST = 'ST',
		 SU = 'SU',
		 SV = 'SV',
		 SW = 'SW',
		 TA = 'TA',
		 TE = 'TE',
		 TG = 'TG',
		 TH = 'TH',
		 TI = 'TI',
		 TK = 'TK',
		 TL = 'TL',
		 TN = 'TN',
		 TO = 'TO',
		 TR = 'TR',
		 TS = 'TS',
		 TT = 'TT',
		 TW = 'TW',
		 TY = 'TY',
		 UG = 'UG',
		 UK = 'UK',
		 UR = 'UR',
		 UZ = 'UZ',
		 VE = 'VE',
		 VI = 'VI',
		 VO = 'VO',
		 WA = 'WA',
		 WO = 'WO',
		 XH = 'XH',
		 YI = 'YI',
		 YO = 'YO',
		 ZA = 'ZA',
		 ZH = 'ZH',
	}


	export enum ActionStatusType {
		 OPEN = 'Open',
		 SENT = 'Sent',
		 ACCEPTED = 'Accepted',
		 EXECUTING = 'Executing',
		 FINISHED = 'Finished',
		 CANCELLED = 'Cancelled',
		 DECLINED = 'Declined',
	}


	export enum ActionType {
		 TOCLEAN = 'ToClean',
		 TOPAINT = 'ToPaint',
		 TOREPAIR = 'ToRepair',
		 TOREPLACE = 'ToReplace',
		 TOINSPECT = 'ToInspect',
		 TOMAINTAIN = 'ToMaintain',
		 TOREBUILD = 'ToRebuild',
		 TOFIX = 'ToFix',
		 TODO = 'ToDo',
		 TOREMOVE = 'ToRemove',
	}


	export enum UrgencyType {
		 URGENT = 'Urgent',
	}


	export enum MultimediumType {
		 VIDEO = 'Video',
		 PICTURE = 'Picture',
		 ANNOTATION = 'Annotation',
		 DRAWING = 'Drawing',
		 SIGNATURE = 'Signature',
		 PDF = 'Pdf',
		 AUDIO = 'Audio',
		 SECURITYDEPOSITSIGNATURE = 'SecurityDepositSignature',
		 ISSUEAUDIO = 'IssueAudio',
	}


	export enum Platform {
		 APPLE = 'Apple',
		 ANDROID = 'Android',
	}


	export enum ProductLabelType {
		 STATEREPORT = 'StateReport',
		 CHAPPSROOMINSPECTOR = 'ChappsRoomInspector',
		 CHAPPSBUILDINGINSPECTOR = 'ChappsBuildingInspector',
		 CHAPPSMAINTENANCE = 'ChappsMaintenance',
		 CHAPPSRESIDENZ = 'ChappsResidenz',
		 AFFAIRS = 'Affairs',
		 SECURITYDEPOSIT = 'SecurityDeposit',
		 USER = 'User',
		 DICTAPHONE = 'Dictaphone',
		 JOBMEN = 'JobMen',
		 REFERENCEREPORT = 'ReferenceReport',
		 TARIFICATION = 'Tarification',
		 SETTLEMENT = 'Settlement',
		 OFFICES = 'Offices',
		 CHAPPPRO = 'ChappPro',
		 CHAPPCORPORATE = 'ChappCorporate',
		 CHAPPLOGIN = 'ChappLogin',
		 CHAPPMANAGER = 'ChappManager',
		 CONFIRMATIONLETTERS = 'ConfirmationLetters',
	}


	export enum ReturnType {
		 OK = 'Ok',
		 SQLQUERYFAILED = 'SqlQueryFailed',
		 INVALIDARGUMENT = 'InvalidArgument',
		 AUTHENTICATIONFAILED = 'AuthenticationFailed',
		 UNSPECIFIEDEXCEPTION = 'UnspecifiedException',
		 UNSUPPORTEDMEDIATYPE = 'UnsupportedMediaType',
	}


	export enum SeverityType {
		 ERROR = 'Error',
		 WARNING = 'Warning',
		 LOGGING = 'Logging',
	}


	export enum SortDirection {
		 ASC = 'Asc',
		 DESC = 'Desc',
	}


	export enum StateType {
		 US_AK = 'US_AK',
		 US_AL = 'US_AL',
		 US_AR = 'US_AR',
		 US_AS = 'US_AS',
		 US_AZ = 'US_AZ',
		 US_CA = 'US_CA',
		 US_CO = 'US_CO',
		 US_CT = 'US_CT',
		 US_DC = 'US_DC',
		 US_DE = 'US_DE',
		 US_FL = 'US_FL',
		 US_GA = 'US_GA',
		 US_GU = 'US_GU',
		 US_HI = 'US_HI',
		 US_IA = 'US_IA',
		 US_ID = 'US_ID',
		 US_IL = 'US_IL',
		 US_IN = 'US_IN',
		 US_KS = 'US_KS',
		 US_KY = 'US_KY',
		 US_LA = 'US_LA',
		 US_MA = 'US_MA',
		 US_MD = 'US_MD',
		 US_ME = 'US_ME',
		 US_MI = 'US_MI',
		 US_MN = 'US_MN',
		 US_MO = 'US_MO',
		 US_MP = 'US_MP',
		 US_MS = 'US_MS',
		 US_MT = 'US_MT',
		 US_NC = 'US_NC',
		 US_ND = 'US_ND',
		 US_NE = 'US_NE',
		 US_NH = 'US_NH',
		 US_NJ = 'US_NJ',
		 US_NM = 'US_NM',
		 US_NV = 'US_NV',
		 US_NY = 'US_NY',
		 US_OH = 'US_OH',
		 US_OK = 'US_OK',
		 US_OR = 'US_OR',
		 US_PA = 'US_PA',
		 US_PR = 'US_PR',
		 US_RI = 'US_RI',
		 US_SC = 'US_SC',
		 US_SD = 'US_SD',
		 US_TN = 'US_TN',
		 US_TX = 'US_TX',
		 US_UM = 'US_UM',
		 US_UT = 'US_UT',
		 US_VA = 'US_VA',
		 US_VI = 'US_VI',
		 US_VT = 'US_VT',
		 US_WA = 'US_WA',
		 US_WI = 'US_WI',
		 US_WV = 'US_WV',
		 US_WY = 'US_WY',
		 CA_AB = 'CA_AB',
		 CA_BC = 'CA_BC',
		 CA_MB = 'CA_MB',
		 CA_NB = 'CA_NB',
		 CA_NL = 'CA_NL',
		 CA_NS = 'CA_NS',
		 CA_ON = 'CA_ON',
		 CA_PE = 'CA_PE',
		 CA_QC = 'CA_QC',
		 CA_SK = 'CA_SK',
		 CA_NT = 'CA_NT',
		 CA_NU = 'CA_NU',
		 CA_YT = 'CA_YT',
	}


